export const PRIMARY_COLORS_BY_BRAND = {
    kerna: '#4c67f3',
    ziphy: '#17a2c6',
};
export const PRIMARY_HOVER_COLORS_BY_BRAND = {
    kerna: '#1A35C1',
    ziphy: '#1386a4',
};
